<div class="common-grid">
  <p-table
    #commonTable
    [value]="data"
    (onSort)="onSort($event)"
    styleClass="p-datatable-striped"
    [resetPageOnSort]="false"
    [paginator]="showPagination && data.length > 0 ? true : false"
    (onPage)="onPageSizeChange($event)"
    [totalRecords]="totalRecords"
    [tableStyle]="{ 'min-height': 'auto', 'min-width': '0rem' }"
    [rows]="pageSize"
    [rowsPerPageOptions]="gridConfig.pageSizeOptions"
    [resizableColumns]="true"
  >
    <ng-template pTemplate="header">
      <tr>
        <th
          *ngFor="let col of headers"
          class="table-header"
          scope="col"
          [id]="col.key"
          [pSortableColumn]="col.key"
          [pSortableColumnDisabled]="col.sort ? false : true"
          [style.width.px]="col.width"
          pResizableColumn
        >
          {{ col.header }}

          <p-sortIcon *ngIf="col.sort" [field]="col.key"></p-sortIcon>
          <i
            *ngIf="col.headerTooltip"
            class="pi pi-info-circle"
            [escape]="false"
            pTooltip="{{ col.headerTooltip }}"
            tooltipPosition="right"
          ></i>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowData>
      <tr class="table-body">
        <td *ngFor="let col of headers" [ngSwitch]="col.type">
          <ng-container *ngSwitchCase="GRID_DATA_TYPE.BUTTONS">
            <ng-container *ngFor="let button of col.buttons">
              <span
                [ngSwitch]="button.buttonType"
                (click)="onButtonClick(rowData, button.eventName)"
                *ngIf="!button.isView || rowData[button.isView]"
                class="{{ button.classes }}"
                [ngClass]=""
                pTooltip="{{ button.tooltipText ? button.tooltipText : '' }}"
                [escape]="false"
                tooltipPosition="top"
                (keydown)="$event.preventDefault()"
                class="common-grid-btn"
              >
                <ng-container *ngSwitchCase="BUTTON_TYPE.ICONBTN">
                  <img
                    alt="icon-btn"
                    src="assets/svg/{{ button.icon }}"
                    href="#"
                  />
                </ng-container>
                <ng-container *ngSwitchCase="BUTTON_TYPE.PRIMEICOM">
                  <i class="pi {{ button.icon }}"></i>
                </ng-container>
              </span>
            </ng-container>
          </ng-container>
          <ng-container *ngSwitchCase="GRID_DATA_TYPE.EXPANDABLELINK">
            <div *ngIf="rowData[col.key] && rowData[col.key]?.length > 0">
              <div class="toggle-container">
                <button
                  class="toggle-btn"
                  (click)="toggleExpandableLinks(rowData)"
                  [attr.aria-expanded]="rowData.showExpandableLinks || false"
                >
                  <i
                    class="pi"
                    [ngClass]="
                      rowData.showExpandableLinks
                        ? 'pi-chevron-up'
                        : 'pi-chevron-down'
                    "
                  ></i>
                  <span>
                    {{ getYesCount(rowData, col.key) }} Yes,
                    {{ getNoCount(rowData, col.key) }} No
                  </span>
                </button>
              </div>
              <div
                class="expandable-links-container"
                *ngIf="rowData.showExpandableLinks"
              >
                <div
                  class="expandable-link mb-1"
                  *ngFor="let url of rowData[col.key]; let i = index"
                >
                  <span>{{ url.placeholderName }} </span>
                  <span [ngClass]="url?.clicks > 0 ? 'success' : 'failed'">{{
                    url?.clicks > 0 ? "Yes" : "No"
                  }}</span>
                </div>
              </div>
            </div>
            <div *ngIf="!rowData[col.key] || rowData[col.key]?.length === 0">
              NA
            </div>
          </ng-container>

          <ng-container *ngSwitchDefault>
            <span
              class="default-span ellipsis"
              [ngClass]="col.classes ? rowData[col.classes] : ''"
              [escape]="false"
              pTooltip="{{
                col.tooltipKey &&
                rowData[col.tooltipKey] &&
                rowData[col.tooltipKey].length > 20
                  ? rowData[col.tooltipKey]
                  : ''
              }}"
              tooltipPosition="top"
            >
              <img
                class="pre-icon"
                *ngIf="col.preIcon"
                src="/assets/svg/{{ rowData[col.preIcon] }}"
                alt="preIcon"
              />
              <i
                *ngIf="col.infoText && rowData[col.infoText]"
                class="pi pi-info-circle"
                [escape]="false"
                pTooltip="{{ rowData[col.infoText] }}"
                tooltipPosition="right"
              ></i>
              <span
                [ngClass]="{
                  'primary-color': col.preIcon || col.postIcon,
                  'bold-class': col.infoText,
                  'text-capitalize': col.header !== 'Recipient ID'
                }"
              >
                {{ rowData[col.key] || "--" }}
              </span>
              <img
                class="post-icon"
                *ngIf="col.postIcon"
                src="/assets/svg/{{ rowData[col.postIcon] }}"
                alt="postIcon"
              />
            </span>
          </ng-container>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage" let-columns>
      <span class="no-data-found">No records found</span>
    </ng-template>
  </p-table>
</div>
